// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2qczU","title":"Info_title__2L6Ug","selects":"Info_selects__-kM6E","requiredAsterisk":"Info_requiredAsterisk__2-UFv"};